<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row>
      <v-col cols="12" md="12">
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'ListclassDosen' }">
          <v-icon left>mdi-archive-check</v-icon> Kelas Aktif
        </v-btn>
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'ArchiveclassDosen' }">
          <v-icon left>mdi-archive</v-icon> Kelas Arsip
        </v-btn>
        <v-btn
          text
          class="text-capitalize mr-1 hover-class-style"
          active-class="active-class-style"
          :to="{ name: 'OtherAbsence' }"
          exact>
          <v-icon left>mdi-receipt-text-clock-outline</v-icon> Presensi Lainnya
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" v-if="false">
        <v-text-field
          dense
          prepend-inner-icon="search"
          v-model="paramclass.keyword"
          label="Nama kelas"
          name="keyword">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0">
      <v-col
        class="d-flex" style="flex-direction:column"
        cols="12"
        md="4"
        v-for="(kelas, i) in datalist"
        :key="i">
        <v-card
          class="flex-grow-1"
          outlined>
          <v-img
            height="80px"
            :lazy-src="require('../../assets/default.jpg')"
            :src="api + '/upload/kelas/' + kelas.bgimg_class">
            <v-app-bar
              dark
              flat
              color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title pl-0">
                <router-link
                  class="white--text text-decoration-none"
                  :to="{ name: 'DetailclassDosen', query: { class: kelas.id_class } }">
                  {{ kelas.nama_class }}
                </router-link>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu
                offset-y
                bottom
                left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    exact>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="editClass(kelas)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="restoreClass(kelas)">
                    <v-list-item-title>Restore</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-app-bar>
          </v-img>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">Semester {{ kelas.semester_class }}</div>
                <div class="font-weight-bold">{{ kelas.matkul_class }}</div>
                <div class="font-weight-bold">Kelas: {{ kelas.mhs_class }}</div>
                <div class="font-weight-bold">Tim Teaching: {{ kelas.s_kelas_tim === '1' ? 'Ya' : 'Tidak' }}</div>
                <div class="font-weight-bold">T.A {{ kelas.year_class }}</div>
              </v-col>
              <v-col cols="12" md="12" class="py-0" v-if="false">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" v-if="false">
                List uncoming
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length <= 0" justify="center">
      <v-col
        cols="12"
        md="12"
        class="text-center black--text">
        <v-img
          contain
          max-width="200"
          class="ma-auto"
          :src="require('../../assets/datanotfound.png')">
        </v-img>
        <h3 class="text-md-h5">
          Tidak ada kelas yang dirsip.
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getClass">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.edit"
      max-width="600px">
      <v-card v-if="dmodaldata.edit">
        <v-card-title class="mb-5">
          <span>Edit data kelas</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.edit = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdate"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        dense
                        v-model="dmodaldata.edit.nama_class"
                        :rules="[rules.required]"
                        label="Nama kelas"
                        name="nama_class"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        dense
                        v-model="dmodaldata.edit.year_class"
                        :rules="[rules.required]"
                        :items="listtahunajaran"
                        label="Tahun ajaran *"
                        name="classajaran">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        dense
                        v-model="dmodaldata.edit.prodi_class"
                        :items="listprodi"
                        :rules="[rules.required]"
                        item-value="nama_prodi"
                        item-text="nama_prodi"
                        label="Program studi *"
                        name="classprodi">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        dense
                        v-model="dmodaldata.edit.semester_class"
                        :rules="[rules.required]"
                        :items="listsemester"
                        label="Semester *"
                        name="classsemester">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        dense
                        v-model="dmodaldata.edit.matkul_class"
                        :rules="[rules.required]"
                        label="Mata Kuliah"
                        name="matkul"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        dense
                        v-model="dmodaldata.edit.angkatan_class"
                        :rules="[rules.required]"
                        :items="listtahunangkatan"
                        label="Tahun angkatan *"
                        name="classthangkatan">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        dense
                        v-model="dmodaldata.edit.mhs_class"
                        :rules="[rules.required]"
                        :items="listclsangkatan"
                        item-value="nama_kmhs"
                        item-text="nama_kmhs"
                        label="Kelas angkatan *"
                        name="classangkatan">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <v-btn
                        block
                        large
                        :loading="loading.updclass"
                        :disabled="loading.updclass || !formupdate.valid"
                        color="success"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dmodal.arch"
      max-width="450px">
      <v-card v-if="dmodaldata.arch">
        <v-card-title>
          <span>Restore kelas</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.arch = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah anda yakin ingin mengaktifkan lagi kelas ini? <br>
            <b>{{ dmodaldata.arch.nama_class }}</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="!issuccess.arch"
            class="ml-2 mb-3"
            depressed
            tile
            small
            color="primary"
            :loading="loading.arch"
            :disabled="loading.arch"
            @click="confirmRestore(dmodaldata.arch)">
            Restore
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'ArchiveclassDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
      updclass: false,
      arch: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listcategory: ['job-fair', 'motivation'],
    listtahunajaran: ['2021-2022', '2022-2023'],
    listtahunangkatan: ['2016', '2017', '2018', '2019', '2020', '2021', '2022'],
    listclsangkatan: [],
    listsemester: ['1', '2', '3', '4', '5', '6', '7', '8'],
    listprodi: [],
    panduan: null,
    paramclass: {
      keyword: '',
      status: 'archived',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    dmodal: {
      edit: false,
      arch: false,
    },
    dmodaldata: {
      edit: null,
      arch: null,
    },
    issuccess: {
      arch: false,
    },
  }),
  mounted() {
    this.getProdi();
    this.getKelasmhs();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    submitUpdate() {
      // console.log(this.dmodaldata.edit);
      this.alertupdate.show = false;
      if (this.$refs.formupdate.validate()) {
        if (this.tokenscr) {
          this.loading.updclass = true;
          this.axios
            .put(
              this.api + '/api/kelas/',
              qs.stringify(
                this.dmodaldata.edit,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.edit.nama_class + ' berhasil diupdate!';
                  this.getClassFilter();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updclass = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updclass = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    editClass(item) {
      // console.log(item);
      this.alertupdate.show = false;
      this.dmodal.edit = true;
      this.dmodaldata.edit = JSON.parse(JSON.stringify(item));
    },
    confirmRestore(item) {
      // console.log(item);
      this.issuccess.arch = false;
      this.alertupdate.show = false;
      if (this.tokenscr) {
        this.loading.arch = true;
        this.axios
          .put(
            this.api + '/api/kelas/restore',
            qs.stringify({
              class: this.dmodaldata.arch.id_class,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.issuccess.arch = true;
                this.alertupdate.show = true;
                this.alertupdate.type = 'success';
                this.alertupdate.text = this.dmodaldata.arch.nama_class + ' berhasil diarsipkan!';
                this.getClassFilter();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.arch = false;
          })
          .catch((error) => {
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.arch = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token!';
      }
    },
    restoreClass(item) {
      // console.log(item);
      this.alertupdate.show = false;
      this.issuccess.arch = false;
      this.dmodal.arch = true;
      this.dmodaldata.arch = JSON.parse(JSON.stringify(item));
    },
    getClassFilter() {
      this.paramclass.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getClass($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher',
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramclass.offset += this.paramclass.limit;
                  this.datalist.push(...resdata.data);
                  if (this.datalist.length < this.paramclass.offset) {
                    $state.complete();
                  } else {
                    $state.loaded();
                  }
                } else {
                  $state.complete();
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getProdi() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/prodi/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listprodi = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    getKelasmhs() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelasmhs/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listclsangkatan = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
